import {Component} from "@angular/core";
import {LocaleService} from "./locale.service";

@Component({
  selector: 'app-language-picker',
  template: `
  <!-- UI Language -->
  <ion-item>
    <ion-label>{{ 'profile.ui-language' | translate }}</ion-label>
    <ion-select
      [(ngModel)]="language"
      cancelText="{{ 'global.cancel' | translate }}"
      okText="{{ 'global.ok' | translate }}"
      [ngModelOptions]="{standalone: true}"
      (ionChange)="setLanguage($event)"
    >
      <ion-option value="da">{{ 'profile.danish' | translate }}</ion-option>
      <ion-option value="en">{{ 'profile.english' | translate }}</ion-option>
    </ion-select>
  </ion-item>
  `,
})
export class LanguagePickerComponent{
  language: string;

  constructor(
    private locale: LocaleService
  ) {
    this.language = locale.getLocale();
  }

  setLanguage(language) {
    this.locale.setLocale(language);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/language-picker/language-picker.component.ts